import { render, staticRenderFns } from "./DialogConfrimAccountNumber.vue?vue&type=template&id=620229a5"
import script from "./DialogConfrimAccountNumber.vue?vue&type=script&lang=js"
export * from "./DialogConfrimAccountNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports